import { createSelector } from 'reselect';

import { convertListToObjectBy } from 'utils/fn';

import { getCatalogData } from '../selectors';

export const getCatalogOutOfStockDetails = (state) =>
  getCatalogData(state).outOfStockProducts || {};
export const getCatalogOutOfStockProducts = (state) => getCatalogData(state).products || {};

/** popup out of stock */
export const getOutOfStockPopupState = (state) =>
  getCatalogOutOfStockDetails(state).outOfStockOpenState;
export const getOutOfStockPopupHeader = (state) => getCatalogOutOfStockDetails(state).header;
export const getOutOfStockAgreementState = (state, id) =>
  !!getCatalogOutOfStockDetails(state).agreementUncheckedState[id];
export const getOutOfStockStorageData = (state) => getCatalogOutOfStockDetails(state).storageData;
const getCatalogProductsListRaw = (state) => getCatalogOutOfStockProducts(state).list || [];
const getCatalogProductsDict = createSelector(
  getCatalogProductsListRaw,
  convertListToObjectBy('id'),
);
export const getOutOfStockProductId = (state) => getCatalogOutOfStockDetails(state).productId;
export const getOutOfStockProductArticle = createSelector(
  getCatalogProductsDict,
  getOutOfStockProductId,
  (dict, productId) => (dict[productId] || {}).article,
);
export const getOutOfStockPopupDescription = createSelector(
  getCatalogProductsDict,
  getOutOfStockProductId,
  (dict, productId) => (dict[productId] || {}).outOfStockMessageTemplate,
);
export const getOutOfStockView = (state) => getCatalogOutOfStockDetails(state).viewState;

/** backend data texts */
export const getCatalogOutOfStockTexts = (state) => getCatalogData(state).outOfStock || {};
export const getOutOfStockSuccessText = (state) =>
  getCatalogOutOfStockTexts(state).successText || '';
export const getOutOfStockErrorText = (state) => getCatalogOutOfStockTexts(state).errorText || '';
export const getOutOfStockAgreementDataText = (state) =>
  getCatalogOutOfStockTexts(state).agreementDataText || '';
